import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { AiFillCaretDown } from 'react-icons/ai';
import Button from '@material-ui/core/Button';
import { cancelCommmand, duplicateCommand } from './commands/commandsActions';

const CommandDrawerTitle = ({
  dispatchDuplicateCommand,
  dispatchCancelCommand,
  currentCommand
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const commandReference = currentCommand.externalReference
    ? currentCommand.externalReference
    : '';

  const handleReferenceClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTappedCommandReference = event => {
    if (anchorEl) {
      return;
    }
    handleReferenceClick(event);
  };

  const handleDuplicate = () => {
    dispatchDuplicateCommand(currentCommand.id);
    handleClose();
  };

  const handleCancel = () => {
    dispatchCancelCommand(currentCommand.id);
    handleClose();
  };

  return (
    <div>
      <div
        style={{
          cursor: 'pointer',
          flexDirection: 'row',
          paddingTop: 20,
          justifyContent: 'space-between'
        }}
      >
        <h1
          style={{ display: 'inline', marginRight: 15 }}
        >{`Référence ${commandReference}`}</h1>
        <Button
          variant="contained"
          color="primary"
          style={{ marginBottom: 5, height: 40, alignSelf: 'flex-end' }}
          title="Action"
          onClick={handleTappedCommandReference}
        >
          <p style={{ display: 'inline' }}>Actions</p>
          <AiFillCaretDown style={{ marginLeft: 5 }} />
        </Button>
      </div>
      <Menu
        id="simple-menu-commands"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ marginLeft: 50 }}
      >
        <MenuItem onClick={handleClose}>
          <ListItemText
            primary="Dupliquer la commande"
            onClick={handleDuplicate}
          />
        </MenuItem>
        {!currentCommand.canBeCancelled ? null : (
          <MenuItem onClick={handleClose}>
            <ListItemText
              primary="Annuler la commande"
              onClick={handleCancel}
            />
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand
});

const mapDispatchToProps = dispatch => ({
  dispatchDuplicateCommand: commandId => dispatch(duplicateCommand(commandId)),
  dispatchCancelCommand: commandId => dispatch(cancelCommmand(commandId))
});

CommandDrawerTitle.propTypes = {
  dispatchDuplicateCommand: PropTypes.func.isRequired,
  currentCommand: PropTypes.object.isRequired,
  dispatchCancelCommand: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(CommandDrawerTitle);
